import Dashboard1 from "../assets/images/Screens/Dashboard/_1.png";
import Dashboard2 from "../assets/images/Screens/Dashboard/_2.png";
import Dashboard3 from "../assets/images/Screens/Dashboard/_3.png";
import Dashboard4 from "../assets/images/Screens/Dashboard/_4.png";
import Dashboard5 from "../assets/images/Screens/Dashboard/_5.png";
import Dashboard6 from "../assets/images/Screens/Dashboard/_6.png";
import Dashboard7 from "../assets/images/Screens/Dashboard/_7.png";
import Analytics1 from "../assets/images/Screens/Analytics/_1.png";
import Analytics2 from "../assets/images/Screens/Analytics/_2.png";
import Analytics3 from "../assets/images/Screens/Analytics/_3.png";
import WOL1 from "../assets/images/Screens/WOL/_1.png";
import WOL2 from "../assets/images/Screens/WOL/_2.png";
import CE1 from "../assets/images/Screens/CE/_1.png";
import CE2 from "../assets/images/Screens/CE/_2.png";
import Events1 from "../assets/images/Screens/Events/_1.png";
import Events2 from "../assets/images/Screens/Events/_2.png";
import Events3 from "../assets/images/Screens/Events/_3.png";
import Events4 from "../assets/images/Screens/Events/_4.png";
import DriverDetail1 from "../assets/images/Screens/DriverDetail/_1.png";
import DriverDetail2 from "../assets/images/Screens/DriverDetail/_2.png";
import DriverDetail3 from "../assets/images/Screens/DriverDetail/_3.png";
import Export1 from "../assets/images/Screens/Export/_1.png";
import AccelerationEvent from "../assets/images/Screens/Events/accelerationEvents.png";
import DistractionEvent from "../assets/images/Screens/Events/distractionEvents.png";
import LocatorScreen from "../assets/images/Screens/Locator/locatorScreen.png";

const helpPopUpFile = {
  dashboard: [
    {
      title: "HELP_WELCOME_TITLE",
      img: Dashboard1,
      text: "HELP_WELCOME_TEXT",
    },
    {
      title: "HELP_DASHBOARD_TITLE",
      img: Dashboard1,
      text: "HELP_DASHBOARD_TEXT",
    },
    {
      title: "HELP_AVERAGE_PRAISO_SCORE_TITLE",
      img: Dashboard2,
      text: "HELP_AVERAGE_PRAISO_SCORE_TEXT",
    },
    {
      title: "HELP_PRAISO_SCORE_TITLE",
      img: Dashboard2,
      text: "HELP_PRAISO_SCORE_TEXT",
    },
    {
      title: "HELP_CONTENT_ENGAGEMENT_TITLE",
      img: Dashboard3,
      text: "HELP_CONTENT_ENGAGEMENT_TEXT",
    },
    {
      title: "HELP_DRIVER_AT_RISK_TITLE",
      img: Dashboard4,
      text: "HELP_DRIVER_AT_RISK_TEXT",
    },
    {
      title: "HELP_CONTENT_ENGAGEMENT_DETAILS_TITLE",
      img: Dashboard5,
      text: "HELP_CONTENT_ENGAGEMENT_DETAILS_TEXT",
    },
    {
      title: "HELP_DRIVER_STANDARDS_TITLE",
      img: Dashboard6,
      text: "HELP_DRIVER_STANDARDS_TEXT",
    },
    {
      title: "HELP_POTENTIAL_PENALTY_POINTS_TITLE",
      img: Dashboard7,
      text: "HELP_POTENTIAL_PENALTY_POINTS_TEXT",
    },
  ],
  analytics: [
    {
      title: "HELP_ANALYTICS_TITLE",
      img: Analytics1,
      text: "HELP_ANALYTICS_TEXT",
    },
    {
      title: "HELP_PRAISO_SCORE_TREND_TITLE",
      img: Analytics2,
      text: "HELP_PRAISO_SCORE_TREND_TEXT",
    },
    {
      title: "HELP_PERFORMANCE_TREND_TITLE",
      img: Analytics3,
      text: "HELP_PERFORMANCE_TREND_TEXT",
    },
  ],
  walloflegends: [
    {
      title: "HELP_WOL_TITLE",
      img: WOL1,
      text: "HELP_WOL_TEXT",
    },
    {
      title: "HELP_WOL_PRAISO_SCORE_TITLE",
      img: WOL1,
      text: "HELP_WOL_PRAISO_SCORE_TEXT",
    },
    {
      title: "HELP_WOL_STATUS_AND_PERFORMANCE_ZONE_TITLE",
      img: WOL2,
      text: "HELP_WOL_STATUS_AND_PERFORMANCE_ZONE_TEXT",
    },
  ],
  engagement: [
    {
      title: "HELP_CE_TITLE",
      img: CE1,
      text: "HELP_CE_TEXT",
    },
    {
      title: "HELP_ENGAGEMENT_SCORE_TITLE",
      img: CE2,
      text: "HELP_ENGAGEMENT_SCORE_TEXT",
    },
  ],
  events: [
    {
      title: "HELP_EVENTS_TITLE",
      img: Events1,
      text: "HELP_EVENTS_TEXT",
    },
    {
      title: "HELP_SPEEDING_TITLE",
      img: Events2,
      text: "HELP_SPEEDING_TEXT",
    },
    {
      title: "HELP_BRAKING_TITLE",
      img: Events3,
      text: "HELP_BRAKING_TEXT",
    },
    {
      title: "HELP_CORNERING_TITLE",
      img: Events4,
      text: "HELP_CORNERING_TEXT",
    },
    {
      title: "HELP_ACCELERATION_TITLE",
      //img: AccelerationEvent,
      text: "HELP_ACCELERATION_TEXT",
    },
    {
      title: "HELP_DISTRACTION_TITLE",
      //img: DistractionEvent,
      text: "HELP_DISTRACTION_TEXT",
    },
  ],
  userdetails: [
    {
      title: "HELP_DRIVER_DETAILS_TITLE",
      img: DriverDetail1,
      text: `HELP_DRIVER_DETAILS_TEXT`,
    },
    {
      title: "HELP_DRIVER_DETAILS_STATS_TITLE",
      img: DriverDetail2,
      text: "HELP_DRIVER_DETAILS_STATS_TEXT",
    },
    {
      title: "HELP_DRIVER_DETAILS_EVENTS_TITLE",
      img: DriverDetail3,
      text: "HELP_DRIVER_DETAILS_EVENTS_TEXT",
    },
  ],
  exports: [
    {
      title: "HELP_EXPORTS_TITLE",
      img: Export1,
      text: "HELP_EXPORTS_TEXT",
    },
    {
      title: "HELP_ENGANEMENT_REPORT_TITLE",
      img: Export1,
      text: "HELP_ENGANEMENT_REPORT_TEXT",
    },
  ],
  locator: [
    {
      title: "HELP_LOCATOR_TITLE",
      //img: LocatorScreen,
      text: "HELP_LOCATOR_TEXT",
    },
  ]
};

export default helpPopUpFile;
